import { Blurhash } from "react-blurhash";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";


export default function Carousel({ image }) {
  const [loaded, setLoaded] = useState(false);

  // Function to handle image load event
  const handleImageLoad = () => {
    setLoaded(true);
  };

  return (
    <Swiper
      slidesPerView={1}
      onSwiper={(swiper) => console.log(swiper)}
      className="Header__Carousel"
      loop
      speed={3000}
      modules={[Autoplay, Navigation]}
      autoplay={{ delay: 5000 }}
      navigation={true}
    >
      {image.map((image, index) => {
        return (
          <SwiperSlide key={index} className={"Header__Carousel__Div"}>
            {!loaded && (
              <div
              className="Header__Carousel__Image"
              >
                <Blurhash
                  hash={`${image.placeholder}`}
                  width="100%"
                  height="100%"
                  resolutionX={32}
                  resolutionY={32}
                  punch={1}
                />
              </div>
            )}
            <img
              alt={"Carousel Image"}
              src={image.img}
              className="Header__Carousel__Image"
              onLoad={handleImageLoad}
            />
            <div
              style={{
                backgroundColor: "rgba(0,0,0,.3)",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                width: "100%",
                height: "100%",
              }}
            ></div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}
